import React from 'react';
import Icon from './Icon';

const Favorites = (props) => (
  <Icon viewBox="0 0 56 56" {...props}>
    <title>Favorites</title>
    <g>
      <path fill="none" stroke="#737373" strokeWidth="4px" fillRule="evenodd" d="M28,20.665a11,11,0,0,1,22,0c0,14.186-22,29.207-22,29.207S6,34.852,6,20.665A11,11,0,0,1,28,20.665Z"/>
    </g>
  </Icon>
);

export default Favorites;
